export const SDS_SEARCH_CUSTOM_EVENTS = {
    CHANGE: 'sds.search.changed',
    INPUT: 'sds.search.input',
    CLEARED: 'sds.search.cleared',
    SUBMIT: 'sds.search.submit',
};
